import {getEndpoint, getHeaders} from '../../helpers/endpoint';

export const REQUEST_GET_JERSEYS = 'REQUEST_GET_JERSEYS';
export const SUCCESS_GET_JERSEYS = 'SUCCESS_GET_JERSEYS';
export const FAIL_GET_JERSEYS = 'FAIL_GET_JERSEYS';

export const getJerseys = (onSuccess, onError) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_GET_JERSEYS});

    return fetch(getEndpoint('getJerseys'), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          if (onError) onError(data.error);
          dispatch({
            type: FAIL_GET_JERSEYS,
            error: data.error,
          });
        } else dispatch(successGetJerseys(data, onSuccess));
      })
      .catch((error, type = FAIL_GET_JERSEYS) => {
        if (onError) onError(error);
        dispatch({type, error});
      });
  };
};

function successGetJerseys(response, onSuccess) {
  if (onSuccess) onSuccess(response);
  return dispatch => {
    dispatch({
      type: SUCCESS_GET_JERSEYS,
      list: response.jerseysTemp,
    });
  };
}

export const REQUEST_UPDATE_JERSEY_INFOS = 'REQUEST_UPDATE_JERSEY_INFOS';
export const SUCCESS_UPDATE_JERSEY_INFOS = 'SUCCESS_UPDATE_JERSEY_INFOS';
export const FAIL_UPDATE_JERSEY_INFOS = 'FAIL_UPDATE_JERSEY_INFOS';

export const updateJerseyInfos = (payload, onSuccess, onError) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_UPDATE_JERSEY_INFOS, payload});

    return fetch(getEndpoint('updateJerseyInfos', payload.id), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify({...payload, type: undefined, id: undefined}),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          if (onError) onError(data.error);
          dispatch({
            type: FAIL_UPDATE_JERSEY_INFOS,
            error: data.error,
          });
        } else dispatch(successUpdateJerseyInfos(data, onSuccess, payload));
      })
      .catch((error, type = FAIL_UPDATE_JERSEY_INFOS) => {
        if (onError) onError(error);
        dispatch({type, error});
      });
  };
};

function successUpdateJerseyInfos(response, onSuccess, payload) {
  if (onSuccess) onSuccess(response);
  return dispatch => {
    dispatch({
      type: SUCCESS_UPDATE_JERSEY_INFOS,
      response,
      payload,
    });
  };
}

export const REQUEST_CREATE_JERSEY = 'REQUEST_CREATE_JERSEY';
export const SUCCESS_CREATE_JERSEY = 'SUCCESS_CREATE_JERSEY';
export const FAIL_CREATE_JERSEY = 'FAIL_CREATE_JERSEY';

export const createJersey = (payload, onSuccess, onError) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_CREATE_JERSEY, payload});

    return fetch(getEndpoint('createJersey'), {
      method: 'POST',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify(payload),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          if (onError) onError(data.error);
          dispatch({
            type: FAIL_CREATE_JERSEY,
            error: data.error,
          });
        } else dispatch(successCreateJersey(data, onSuccess, payload));
      })
      .catch((error, type = FAIL_CREATE_JERSEY) => {
        if (onError) onError(error);
        dispatch({type, error});
      });
  };
};

function successCreateJersey(response, onSuccess, formData) {
  if (onSuccess) onSuccess(response);
  return dispatch => {
    dispatch({
      type: SUCCESS_CREATE_JERSEY,
      response,
      formData,
    });
  };
}

export const REQUEST_GET_COLLECTIONS = 'REQUEST_GET_COLLECTIONS';
export const SUCCESS_GET_COLLECTIONS = 'SUCCESS_GET_COLLECTIONS';
export const FAIL_GET_COLLECTIONS = 'FAIL_GET_COLLECTIONS';

function normalizeCollections(data) {
  if (!data || data.jerseyCollectionsTemp) return data;
  return {
    ...data,
    jerseyCollectionsTemp: [
      ...(data.pinnedCollections || []),
      ...(data.collections || []),
    ],
  };
}

export const getCollections = (payload, onSuccess, onError) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_GET_COLLECTIONS});

    return fetch(getEndpoint('getCollections', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          if (onError) onError(data.error);
          dispatch({
            type: FAIL_GET_COLLECTIONS,
            error: data.error,
          });
        } else dispatch(successGetCollections(normalizeCollections(data), onSuccess));
      })
      .catch((error, type = FAIL_GET_COLLECTIONS) => {
        if (onError) onError(error);
        dispatch({type, error});
      });
  };
};

function successGetCollections(response, onSuccess) {
  if (onSuccess) onSuccess(response);
  return dispatch => {
    dispatch({
      type: SUCCESS_GET_COLLECTIONS,
      response,
    });
  };
}

export const REQUEST_UPDATE_COLLECTION_INFOS =
  'REQUEST_UPDATE_COLLECTION_INFOS';
export const SUCCESS_UPDATE_COLLECTION_INFOS =
  'SUCCESS_UPDATE_COLLECTION_INFOS';
export const FAIL_UPDATE_COLLECTION_INFOS = 'FAIL_UPDATE_COLLECTION_INFOS';

export const updateCollectionInfos = (
  payload,
  language,
  collectionId,
  onSuccess,
  onError,
) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_UPDATE_COLLECTION_INFOS, payload});
    return fetch(
      getEndpoint('updateCollectionInfos', {collectionId, language}),
      {
        method: 'PATCH',
        headers: getHeaders(getState().authentication),
        body: JSON.stringify(payload),
      },
    )
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          if (onError) onError(data);
          dispatch({
            type: FAIL_UPDATE_COLLECTION_INFOS,
            error: data.error,
          });
        } else dispatch(successUpdateCollectionInfos(data, onSuccess, payload));
      })
      .catch((error, type = FAIL_UPDATE_COLLECTION_INFOS) => {
        if (onError) onError(error);
        dispatch({type, error});
      });
  };
};

function successUpdateCollectionInfos(response, onSuccess, payload) {
  if (onSuccess) onSuccess(response);
  return dispatch => {
    dispatch({
      type: SUCCESS_UPDATE_COLLECTION_INFOS,
      response,
      payload,
    });
  };
}

export const REQUEST_ORDER_COLLECTIONS = 'REQUEST_ORDER_COLLECTIONS';
export const SUCCESS_ORDER_COLLECTIONS = 'SUCCESS_ORDER_COLLECTIONS';
export const FAIL_ORDER_COLLECTIONS = 'FAIL_ORDER_COLLECTIONS';

export const orderCollections = (payload, onSuccess, onError) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_ORDER_COLLECTIONS, payload});

    return fetch(getEndpoint('orderCollections'), {
      method: 'POST',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify(payload),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          if (onError) onError(data.error);
          dispatch({
            type: FAIL_ORDER_COLLECTIONS,
            error: data.error,
          });
        } else dispatch(successOrderCollections(data, onSuccess, payload));
      })
      .catch((error, type = FAIL_ORDER_COLLECTIONS) => {
        if (onError) onError(error);
        dispatch({type, error});
      });
  };
};

function successOrderCollections(response, onSuccess, payload) {
  if (onSuccess) onSuccess(response);
  return dispatch => {
    dispatch({
      type: SUCCESS_ORDER_COLLECTIONS,
      response,
      payload,
    });
  };
}

export const REQUEST_CREATE_COLLECTION = 'REQUEST_CREATE_COLLECTION';
export const SUCCESS_CREATE_COLLECTION = 'SUCCESS_CREATE_COLLECTION';
export const FAIL_CREATE_COLLECTION = 'FAIL_CREATE_COLLECTION';

export const createCollection = (payload, onSuccess, onError) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_CREATE_COLLECTION, payload});

    return fetch(getEndpoint('createCollection'), {
      method: 'POST',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify(payload),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          if (onError) onError(data);
          dispatch({
            type: FAIL_CREATE_COLLECTION,
            error: data.error,
          });
        } else dispatch(successCreateCollection(data, onSuccess, payload));
      })
      .catch((error, type = FAIL_CREATE_COLLECTION) => {
        if (onError) onError(error);
        dispatch({type, error});
      });
  };
};

function successCreateCollection(response, onSuccess, payload) {
  if (onSuccess) onSuccess(response);
  return dispatch => {
    dispatch({
      type: SUCCESS_CREATE_COLLECTION,
      response,
      payload,
    });
  };
}

export const REQUEST_GET_JERSEY_SHOP = 'REQUEST_GET_JERSEY_SHOP';
export const SUCCESS_GET_JERSEY_SHOP = 'SUCCESS_GET_JERSEY_SHOP';
export const FAIL_GET_JERSEY_SHOP = 'FAIL_GET_JERSEY_SHOP';

export const getJerseyShop = (payload, onSuccess, onError, onRequest) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_GET_JERSEY_SHOP});
    if (onRequest) onRequest(payload.useTemp);
    return fetch(getEndpoint('getJerseyShop', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          if (onError) onError(data.error);
          dispatch({
            type: FAIL_GET_JERSEY_SHOP,
            error: data.error,
          });
        } else dispatch(successGetJerseyShop(data, onSuccess, payload));
      })
      .catch((error, type = FAIL_GET_JERSEY_SHOP) => {
        if (onError) onError(error);
        dispatch({type, error});
      });
  };
};

function successGetJerseyShop(response, onSuccess, payload) {
  if (onSuccess) onSuccess(response, payload.useTemp);
  return dispatch => {
    dispatch({
      type: SUCCESS_GET_JERSEY_SHOP,
      response,
    });
  };
}

export const REQUEST_UPDATE_JERSEY_SHOP = 'REQUEST_UPDATE_JERSEY_SHOP';
export const SUCCESS_UPDATE_JERSEY_SHOP = 'SUCCESS_UPDATE_JERSEY_SHOP';
export const FAIL_UPDATE_JERSEY_SHOP = 'FAIL_UPDATE_JERSEY_SHOP';

export const updateJerseyShop = (payload, onSuccess, onError) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_UPDATE_JERSEY_SHOP});

    return fetch(getEndpoint('updateJerseyShop', payload.language), {
      method: 'POST',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          if (onError) onError(data.error);
          dispatch({
            type: FAIL_UPDATE_JERSEY_SHOP,
            error: data.error,
          });
        } else dispatch(successUpdateJerseyShop(data, onSuccess));
      })
      .catch((error, type = FAIL_UPDATE_JERSEY_SHOP) => {
        if (onError) onError(error);
        dispatch({type, error});
      });
  };
};

function successUpdateJerseyShop(response, onSuccess) {
  if (onSuccess) onSuccess(response);
  return dispatch => {
    dispatch({
      type: SUCCESS_UPDATE_JERSEY_SHOP,
      response,
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/entities/jerseys.js